import React from "react";

const ItalianMapChart = ({ datasets, maxHeight }) => {

  const regionCoordinates = (region) => {
    switch (region.toLowerCase()) {
      case "abruzzo":
        return [49, 63];
        break;
      case "basilicata":
        return [65, 81];
        break;
      case "calabria":
        return [76, 84];
        break;
      case "campania":
        return [61, 72];
        break;
      case "emilia romagna":
        return [26, 40];
        break;
      case "friuli venezia giulia":
        return [9, 56];
        break;
      case "lazio":
        return [52, 52];
        break;
      case "liguria":
        return [26.5, 19];
        break;
      case "lombardia":
        return [14, 28];
        break;
      case "marche":
        return [36, 56];
        break;
      case "molise":
        return [54, 69];
        break;
      case "piemonte":
        return [21, 11];
        break;
      case "puglia":
        return [58, 82];
        break;
      case "sardegna":
        return [68, 20];
        break;
      case "sicilia":
        return [92, 64];
        break;
      case "toscana":
        return [37, 40];
        break;
      case "trentino alto adige":
        return [7, 40];
        break;
      case "umbria":
        return [41, 51];
        break;
      case "valle d'aosta":
        return [13, 7];
        break;
      case "veneto":
        return [15, 48];
        break;
      default:
        return [100, 0];
    }
  }

  return (
    <div className="d-flex justify-content-center m-auto">
      <div className="position-relative">
        <img src={window.location.origin + '/images/italia.png'}  style={{ maxHeight: maxHeight ? maxHeight : 'auto' }} />

        {
          Object.keys(datasets[0].data).map((region, i) => {
            const originalValue = datasets[0].data[region];
            const numericValue = parseFloat(originalValue.toString().replaceAll('%', '').replaceAll('€', ''));
            const maxValue = Math.max(...(Object.values(datasets[0].data).map(v => v.toString().replaceAll('%', '').replaceAll('€', ''))));
            const dimension = maxValue && maxValue > 0 ? Math.max( 50, (100.0 * numericValue) / maxValue) : 50;
            const coordinates = regionCoordinates(region);

            return <div
              key={region}
              className="position-absolute d-flex justify-content-center align-items-center text-center br-50perc"
              style={{
                top: `calc(${coordinates[0]}% - ${dimension / 2}px)`,
                left: `calc(${coordinates[1]}% - ${dimension / 2}px)`,
                width: dimension,
                height: dimension,
                borderColor: datasets[0].borderColor[i],
                borderWidth: '2px',
                borderStyle: 'solid',
                backgroundColor: datasets[0].backgroundColor[i]
              }}
            >
              <b className="color-white">{originalValue}</b>
              {/*<div className="d-block">*/}
              {/*  <b className="color-white">{originalValue}</b>*/}
              {/*  <p className="m-0"><small>{region}</small></p>*/}
              {/*</div>*/}
            </div>
          })
        }
      </div>
    </div>
  );
};

export default ItalianMapChart;